import { Workbox } from "workbox-window";

if ("serviceWorker" in navigator) {
    const wb = new Workbox("/sw.js");
    wb.addEventListener("waiting", () => {
        console.log(
            "A new service worker has installed, but it can't activate" +
                "until all tabs running the current version have fully unloaded.",
        );
    });
    wb.addEventListener("activated", () => {
        wb.messageSW({
            type: "SKIP_WAITING",
        });
    });
    wb.register().then((reg) => {
        (reg || wb).update();
    });
}
